import { useState, useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import api from "../../services/api";
import Spinner from "../../shared/Spinner/Spinner";
import Style from "./ContractTemplateStyle";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { FaTrashAlt } from "react-icons/fa";
import { FaRegCheckCircle, FaRegCircle, FaFileDownload } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";


export default function ContractTemplate(props) {
  const [loading, setLoading] = useState(true);
  const [contractTemplates, setContractTemplates] = useStateIfMounted({} as any);
  const [showPopUp, setShowPopUp] = useState(false);
  const [message, setMessage] = useState({ success: "", error: "" });
  const [bodyPopup, setBodyPopup] = useState({ title: "", body: "", primaryText: "", secondaryText: "", primaryOnClick: {} as any })

  useEffect(() => {
    LoadTemplates();
  }, []);

  async function LoadTemplates() {
    setLoading(true);
    try {
      const result = await api.get("/contractsTemplates");
      if (result.data.success) {
        const contractTemplate = result.data.templates;
        setContractTemplates(contractTemplate);
        setLoading(false);
      } else {
        setMessage({ success: "", error: "Não foi possivel consultar os templates de contrato: " + result.data })
        setLoading(false);
      }
    } catch (error) {
      setMessage({ success: "", error: "Erro ao consultar os templates de contrato: " + error })
      setLoading(false);
    }
    setLoading(false);
  }


  async function onSubmitUpdateClients(template) {
    try {
      setLoading(true);
      const data = {
        updateClients: !template.updateClients
      }
      const result = await api.put(`/contractsTemplates/${template.id}`, data);
      if (result.data.success) {
        setMessage({ success: "Atualização automática " + (data.updateClients ? "ativado" : "desativado") + " com sucesso!", error: "" });
      } else {
        setMessage({ success: "", error: "Não foi possivel " + (data.updateClients ? "ativar" : "desativar") + " a atualização automática!" });
      }
      await LoadTemplates();
      onClosePopUp();
      setLoading(false);
    }
    catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message });
    }
  }

  async function onSubmitAutoContract(template) {
    try {
      setLoading(true);
      const data = {
        automaticallyGenerate: !template.automaticallyGenerate
      }
      const result = await api.put(`/contractsTemplates/${template.id}`, data);
      if (result.data.success) {
        setMessage({ success: "Geração de contrato automático " + (data.automaticallyGenerate ? "ativado" : "desativado") + " com sucesso!", error: "" });
      } else {
        setMessage({ success: "", error: "Não foi possivel " + (data.automaticallyGenerate ? "ativar" : "desativar") + " a geração do contrato automático!" });
      }
      await LoadTemplates();
      onClosePopUp();
      setLoading(false);
    }
    catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
    }

  }

  async function onSubmitFurnitureImages(template) {
    try {
      setLoading(true);
      const data = {
        showFurnitureImages: !template.showFurnitureImages
      }
      const result = await api.put(`/contractsTemplates/${template.id}`, data);
      if (result.data.success) {
        setMessage({ success: "Exibição das imagens dos imóveis no contrato " + (data.showFurnitureImages ? "ativado" : "desativado") + " com sucesso!", error: "" });
      } else {
        setMessage({ success: "", error: "Não foi possivel " + (data.showFurnitureImages ? "ativar" : "desativar") + " a exibição das imagens dos imóveis no contrato!" });
      }
      await LoadTemplates();
      onClosePopUp();
      setLoading(false);
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message });
    }

  }

  async function onSubmitEnable(template) {
    try {
      setLoading(true);
      const data = {
        enabled: !template.enabled
      }
      const result = await api.put(`/contractsTemplates/${template.id}`, data);
      if (result.data.success) {
        setMessage({ success: "Template de contrato " + (data.enabled ? "habilitado" : "desabilitado") + " com sucesso!", error: "" });
      } else {
        setMessage({ success: "Não foi possivel " + (data.enabled ? "habilitar" : "desabilitar") + " o template de contrato!", error: "" });
      }
      await LoadTemplates();
      onClosePopUp();
      setLoading(false);
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message });
    }
  }

  async function onSubmitDelete(template) {
    try {
      setLoading(true);
      const result = await api.delete(`/contractsTemplates/${template.id}`);
      if (result.data.success) {
        setMessage({ success: "Template de contrato deletado.", error: "" });
      } else {
        setMessage({ success: "", error: "Problema ao deletar o template de contrato: " + result.data });
      }
      await LoadTemplates();
      onClosePopUp()
      setLoading(false);
    } catch (error: any) {
      onClosePopUp();
      setLoading(false);
      setMessage({ success: "", error: error?.response?.data?.message })
    }
  }

  function onOpenUpdateClients(template) {
    let action = template.updateClients ? "desativar" : "ativar";
    setBodyPopup({
      title: "Atualizar automaticamente o contrato?",
      body: `Você tem certeza que deseja ${action} a atualização automática de contrato no template ID ${template.id}?`,
      primaryText: action,
      secondaryText: "Fechar",
      primaryOnClick: () => onSubmitUpdateClients(template)
    })
    setShowPopUp(true);
  }

  function onOpenAutoContract(template) {
    let action = template.automaticallyGenerate ? "desativar" : "ativar";
    setBodyPopup({
      title: "Gerar contrato automático?",
      body: `Você tem certeza que deseja ${action} a geração automática de contrato no template ID: ${template.id}?`,
      primaryText: action,
      secondaryText: "Fechar",
      primaryOnClick: () => onSubmitAutoContract(template)
    })
    setShowPopUp(true);
  }

  function onOpenFurnitureImages(template) {
    let action = template.showFurnitureImages ? "desativar" : "ativar";
    setBodyPopup({
      title: "Mostrar imagens de imóveis no contrato?",
      body: `Você tem certeza que deseja ${action} a exibição das imagens dos imóveis no contrato de template ID ${template.id}?`,
      primaryText: action,
      secondaryText: "Fechar",
      primaryOnClick: () => onSubmitFurnitureImages(template)
    })
    setShowPopUp(true);
  }

  function onOpenEnable(template) {
    let action = template.enabled ? "desabilitar" : "habilitar";
    setBodyPopup({
      title: "Habilitar template de contrato?",
      body: `Você tem certeza que deseja ${action} o template de contrato ID ${template.id}?`,
      primaryText: action,
      secondaryText: "Fechar",
      primaryOnClick: () => onSubmitEnable(template)
    })
    setShowPopUp(true);
  }

  async function onOpenDelete(template) {
    setBodyPopup({
      title: "Deleção de template de contrato?",
      body: `Você tem certeza que deseja deletar o template de contrato ID ${template.id}?`,
      primaryText: "Deletar",
      secondaryText: "Fechar",
      primaryOnClick: () => onSubmitDelete(template)
    })
    setShowPopUp(true);
  }

  function onClosePopUp() {
    setShowPopUp(false);
  }


  if (loading) return (<Spinner spinning={loading} />);
  return (
    <Style>
      <PageTitle title="Templates dos contratos" />
      <TwoButtonsModal
        show={showPopUp}
        onHide={onClosePopUp}
        loading={loading}
        title={bodyPopup.title}
        body={bodyPopup.body}
        secondaryText={bodyPopup.secondaryText}
        secondaryOnClick={onClosePopUp}
        secondaryDisabled={loading}
        primaryText={bodyPopup.primaryText}
        primaryOnClick={bodyPopup.primaryOnClick}
        primaryDisabled={loading}
      />

      {message.error && <p className="alert alert-error">Erro: {message.error}</p>}
      {message.success && <p className="alert alert-info">{message.success}</p>}
      <section className="table-title">
        <h1>Templates</h1>
        <button onClick={() => props.history.push('/contracts/templates/create')}>Novo template</button>
      </section>
      <table className="table-striped table-bordered table-hover main-table">
        <thead>
          <tr>
            <th>Id</th>
            <th>Atualizar Cliente</th>
            <th>Contrato automático</th>
            <th>Mostrar imagens de imóveis</th>
            <th>Habilitar</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {contractTemplates?.length > 0 && contractTemplates.map(template => {
            return (
              <tr key={template.id}>
                <td className="clickable">{template.id}</td>
                <td onClick={() => onOpenUpdateClients(template)} className="clickable">
                  {template.updateClients ?
                    <div className="action">
                      <FaRegCheckCircle className="icon" />
                    </div> :
                    <div className="action">
                      <FaRegCircle className="icon" />
                    </div>
                  }
                </td>
                <td onClick={() => onOpenAutoContract(template)} className="clickable">
                  {template.automaticallyGenerate ?
                    <div className="action">
                      <FaRegCheckCircle className="icon" />
                    </div> :
                    <div className="action">
                      <FaRegCircle className="icon" />
                    </div>
                  }
                </td>
                <td onClick={() => onOpenFurnitureImages(template)} className="clickable">
                  {template.showFurnitureImages ?
                    <div className="action">
                      <FaRegCheckCircle className="icon" />
                    </div> :
                    <div className="action">
                      <FaRegCircle className="icon" />
                    </div>
                  }
                </td>
                <td onClick={() => onOpenEnable(template)} className="clickable">
                  {template.enabled ?
                    <div className="action">
                      <FaRegCheckCircle className="icon" />
                    </div> :
                    <div className="action">
                      <FaRegCircle className="icon" />
                    </div>
                  }
                </td>
                <td className="action">
                  <button onClick={() => onOpenDelete(template)}><FaTrashAlt /></button>
                  <a href={template.templateUrl} download target="_blank" rel="noreferrer" ><FaFileDownload /></a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>


    </Style>
  );
}